import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import {
  useAuth,
  useSidebar,
  useUserOnboarding,
  useTour,
  useMeeting,
} from "@hooks";
import { UserOnboarding, ToggleButtonGroup } from "@components";
import { $Routes } from "@routes";

const AttendeeAndHostToggle = ({ isHostOrCoHost }) => {
  const [userMode, setUserMode] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { runTour, stepIndex, handleTooltipCallback, updatingIsFirstView } = useUserOnboarding();
  const { isHostTour } = useTour();
  const { profile } = useAuth();
  const { isProView } = useSidebar();
  const { currentAgenda } = useMeeting();

  const isRootPage = location.pathname === $Routes.rootPage;

  useEffect(() => {
    setUserMode(isProView ? "host" : isRootPage ? "engage" : "");
  }, [isProView, isRootPage]);

  const linkPath =
    isHostOrCoHost(profile?._id) &&
    currentAgenda &&
    currentAgenda?.userId === profile?._id
      ? `${$Routes.agendaDetailPage}/${currentAgenda._id}`
      : $Routes.allAgendaPage;

  return (
    <UserOnboarding
      isLoading={updatingIsFirstView}
      isOpen={!isHostTour && runTour && stepIndex === 3}
      index={stepIndex}
      onClick={handleTooltipCallback}
    >
      <ToggleButtonGroup
        onChange={setUserMode}
        value={userMode}
        mr={2}
        bg="purple.700"
        p={1.5}
        borderRadius="8px"
      >
        <Button
          variant="primary"
          value="engage"
          size="sm"
          bg="blue.500"
          _hover={{
            bg: "blue.500"
          }}
          onClick={() => navigate($Routes.rootPage)}
          data-testid="engage-button"
        >
          Engage
        </Button>
        <Button
          variant="primary"
          value="host"
          size="sm"
          onClick={() => navigate(linkPath)}
          data-testid="host-button"
        >
          Host
        </Button>
      </ToggleButtonGroup>
    </UserOnboarding>
  )
}

export default AttendeeAndHostToggle;
